import FormSystemError from '../../../utils/form-error-constants';
import Tooltip from '../tooltip';
import WishListService from '../Dashboard/wishListService';

class Wishlist {
    constructor() {
        this.wishListService = new WishListService();

        this.formErrorConstants = new FormSystemError('#favoritesForm');
        this.formErrorConstants.init();

        $('.inputText').keypress(event => {
            this.removeErrorDiv(event.target);
        });

        this.sendFavoritesMail();

        $('.accountContainer .accountContent .productCards button.addToWishlist').on('click', (event) => {
            this.wishListService.toggleWishList($(event.currentTarget))
                .then(() => {
                    $(event.currentTarget).parent().hide();
                    $('#cartForm > input:hidden[value=' + this.wishListService.prodLevId + ']').remove();
                });
        });

        this.selectWishlist();
    }

    sendFavoritesMail() {
        let self = this;
        let tooltip = new Tooltip();
        tooltip.init();
        let $form = $('#favoritesForm');

        $form.on('click', '.check-form', {'$form': $form},  event => {
            let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let allowSendForm = true;
            event.preventDefault();
            self.formErrorConstants.removeErrors($form);
            self.formErrorConstants.removeDataError($form);
            $form.find('textarea').removeAttr('data-error');
            $form.find('input:required, textarea:required').not(':button, :hidden').each(function (i, element) {
                let errorMessage = $(element).data('error-message');
                if (errorMessage) {
                    let value = $(element).val();
                    if (!value || value.length === 0) {
                        allowSendForm = false;
                        if ($(element).attr('name') === 'message') {
                            errorMessage = 'message_required';
                        }
                        $(element).attr('data-error', errorMessage);
                    }
                    if ($(element).attr('type') === 'email') {
                        if (value && !regex.test(value)) {
                            allowSendForm = false;
                            $(element).attr('data-error', 'email');
                        }
                    }
                }
            });
            if (!allowSendForm) {
                this.formErrorConstants.init();
                return false;
            }

            initialCaptchaV2();

            return false;
        });

      $form.on('submit', {'$form': $form},  event => {
        event.preventDefault();

        $.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          context: this,
          data: $form.serialize()
        }).done(() => {
          this.displayFormSuccess($form);
        }).fail(() => {
          this.displayFormError($form);
        }).always(() => {
          $form.find('input,textarea#message').slice(0,3).each(function (i, input) {
            $(input).val('');
          });
        });
      });

    }

    displayFormSuccess($form) {
        let noticeClass = 'notice notice-success';
        let message = this.formErrorConstants.constants.wishlist_email_success;
        $form.find('.formMessage').removeClass('hidden').addClass(noticeClass).text(message);
    }

    displayFormError($form) {
        let noticeClass = 'notice notice-error';
        let message = this.formErrorConstants.constants.wishlist_email_error;
        $form.find('.formMessage').removeClass('hidden').addClass(noticeClass).text(message);
    }

    removeErrorDiv(element) {
        let errorDiv = $(element).closest('.fieldBlock').find('.notice-error');
        if (errorDiv.length) {
            errorDiv.remove();
        }
    }

    selectWishlist() {
        let productFeature= $('.productFeature');

        productFeature.on('click', 'a.cartOrder', (event) => {
            let $this = $(event.currentTarget);
            let productFeature = $this.closest('.productFeature');

            if (productFeature.find('a.cartOrder').attr('href') === '#') {
                event.preventDefault();
                productFeature.find('.dropdown').append("<div class='warning'><img src='/svg/icon-error.svg'><span>Select a version</span></div>");
            }
        });

        productFeature.on('click', 'button.selection', (event) => {
            let $this = $(event.currentTarget);
            let $subling = $this.closest('.dropdown').find('.panel');
            let isWishlistProductOption =  $subling.hasClass('wishlist-product-option');
            this.removeWhistlesProductOption();

            if (!isWishlistProductOption) {
                $subling.addClass('wishlist-product-option');
            }
        });

        $(document).on('click', 'body', (event) => {
            let $this = $(event.target);
            let exceptElements = (!$this.hasClass('selection') && !$this.parent().hasClass('selection'))
                && (!$this.hasClass('select-product') && !$this.parent().hasClass('select-product'));

            if (exceptElements) {
                this.removeWhistlesProductOption();
            }
        });

        productFeature.on('click', '.wishlist-product-option a', (event) => {
            let $this = $(event.currentTarget);
            let prodlevid = $this.attr('data-prodlevid');
            let productFeature = $this.closest('.productFeature');
            let selection = productFeature.find('.selection');
            let selectionSpan = productFeature.find('.selection').find('span');
            let cartElement = productFeature.find('a.cartOrder');
            let currentProdlevid = selection.attr('data-prodlevid');
            let width = 0;

            if (cartElement.length === 1) {
                cartElement.attr('href', $this.attr('data-url'));
                width = parseInt(selection.width()) - 10;
                selectionSpan.width(width);
                selectionSpan.html($this.find('span').html());

                if (currentProdlevid !== prodlevid) {
                    $('#cartForm').find('.product-wishlist').each(function (index, element) {
                        let $element = $(element);
                        if ($element.val() === currentProdlevid) {
                            selection.attr('data-prodlevid', prodlevid);
                            $element.val(prodlevid)
                        }
                    });
                }
            }

            this.removeWhistlesProductOption();
        });
    }

    removeWhistlesProductOption() {
        $('.productFeature').find('.wishlist-product-option').removeClass('wishlist-product-option');
    }
}

$(document).ready(function () {
    new Wishlist();
});
